const coachesArr = [
  {
    image: "../../../img/sadchikov_p.png",
    name: "Павел Садчиков",
    post: "Руководитель и старший тренер ТСК «Агон»",
  },
  {
    image: "../../../img/sviridov.png",
    name: "Александр Свиридов",
    post: "Тренер ТСК «Агон»",
  },
  {
    image: "../../../img/shabanov.png",
    name: "Максим Шабанов",
    post: "Тренер ТСК «Агон»",
  },
  {
    image: "../../../img/sadchikov_o.png",
    name: "Олег Садчиков",
    post: "Тренер ТСК «Агон»",
  },
  {
    image: "../../../img/kravtsova.png",
    name: "Алина Кравцова",
    post: "Тренер ТСК «Агон»",
  },
  {
    image: "../../../img/sadchikova.png",
    name: "Анна Садчикова",
    post: "Тренер ТСК «Агон»",
  },
  {
    image: "../../../img/maslov.png",
    name: "Дмитрий Маслов",
    post: "Тренер ТСК «Агон»",
  },
  {
    image: "../../../img/tuliakov.png",
    name: "Семён Туляков",
    post: "Тренер ТСК «Агон»",
  },
];

coachesArr.forEach((el) => {
  $(".coaches__field .swiper-wrapper").append(`
    <div class="coach swiper-slide">
      <div class="coach__img">
        <img src="${el.image}" alt="" />
      </div>
      <div class="coach__text">
        <p class="coach__text-name">${el.name}</p>
        <p class="coach__text-head">${el.post}</p>
      </div>
    </div>
  `);
});

const coachesSlider = new Swiper(".coaches__field", {
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 8,
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 8,
    },
    1000: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

$(".coaches__top-thumbs .arrow.prev").on("click", () => {
  coachesSlider.slidePrev();
});

$(".coaches__top-thumbs .arrow.next").on("click", () => {
  coachesSlider.slideNext();
});
